import React, { useState, useEffect } from "react";
import { DatePicker, TimePicker } from "@atlaskit/datetime-picker";

const DateTimePicker = ({ onFromChange, onToChange }) => {
  const [fromDate, setFromDate] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toDate, setToDate] = useState("");
  const [toTime, setToTime] = useState("");

  const getTimestamp = (date, time) => {
    if (!date) return null;
    const combined = new Date(`${date}T${time || "00:00"}`);
    return isNaN(combined.getTime()) ? null : combined.getTime();
  };
  const generateAllTimes = () => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let min = 0; min < 60; min += 30) {
        const h = hour.toString().padStart(2, "0");
        const m = min.toString().padStart(2, "0");
        times.push(`${h}:${m}`);
      }
    }
    return times;
  };

  const allTimes = generateAllTimes();
  useEffect(() => {
    onFromChange(getTimestamp(fromDate, fromTime));
  }, [fromDate, fromTime]);

  useEffect(() => {
    onToChange(getTimestamp(toDate, toTime));
  }, [toDate, toTime]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap", zIndex: 2000 }}>
      <DatePicker
        spacing="compact"
        dateFormat="YYYY-MM-DD"
        id="from-date"
        value={fromDate}
        onChange={(value) => setFromDate(value || "")}
      />
      <TimePicker spacing="compact" timeFormat="HH:mm" value={fromTime} onChange={(value) => setFromTime(value || "")} times={allTimes} />

      <span>–</span>

      <DatePicker spacing="compact" dateFormat="YYYY-MM-DD" id="to-date" value={toDate} onChange={(value) => setToDate(value || "")} />
      <TimePicker spacing="compact" timeFormat="HH:mm" value={toTime} onChange={(value) => setToTime(value || "")} times={allTimes} />
    </div>
  );
};

export default DateTimePicker;
